module.exports = {
  gatsbyConfig: {
    property: 'coppercolorado',
    copyrightTagline: 'Copper Mountain',
    siteName: 'Copper Mountain',
    siteUrl: 'https://www.coppercolorado.com',
    reCaptchaDBPropertyName: 'Copper',
    reCaptchaPublicKey: '6LfiiYIUAAAAAEvSxGg7A_ZOQRemWMgGBoTr0Z5P',
    osano: {
      customerId: 'AzqLgKU480gvIIMEX',
      configId: '26417912-36c6-425d-b955-e218b031792c',
    },
    onetrustID: '0196015a-fe66-7157-8f4e-b489f94ae50f-test',
    color: '#18D5EE',
    facebook: 'CopperMtnTest',
    instagram: 'coppermtn',
    twitter: 'CopperMtn',
    dynamicTypes: [
      'event',
      'pressRelease',
      'blog',
    ],
    ignore404Routes: [
      '/things-to-do/events/november-events',
      '/things-to-do/events/december-events',
      '/things-to-do/events/january-events',
      '/things-to-do/events/february-events',
      '/things-to-do/events/march-events',
      '/things-to-do/events/april-events',
      '/culture/blog/all-blogs',
      '/press-room/press-releases/latest-press-releases',
    ],
  },
  // TODO: Good way of managing API keys per site, maybe use for formbucket and mailchimp?
  contentfulConfig: {
    spaceId: '38vc2unmqsq5',
    accessToken: 'D2b0ZG2uKbPvWdW38GS0y3_hQN9AxH-iJnKijjoI0cA',
  },
};
